import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import StarterKit from '@tiptap/starter-kit';

import { SectionBoundary } from './SectionBoundary';
import { VariableChip } from './VariableChip';

/**
 * Frozen extension allowlist for the letter editor (2026-05-28 design rule).
 *
 * MUST match common/letter_html.py ALLOWED_TAGS byte-for-byte:
 *   p, h2, h3, ul, ol, li, strong, em, a (href), br
 * plus the span[data-variable] VariableChip atom node.
 *
 * `sectionBoundaries` is an ADDITIVE, opt-in flag (default OFF). When off the
 * returned allowlist is unchanged — RichTextEditor/index.js and its test stay
 * green. Only the unified letter editor (LTR-08) turns it on to append the
 * frontend-only SectionBoundary mapping anchor; that node is never serialized
 * to stored content.
 */
export function buildExtensions({
  placeholder = 'Start typing the letter…',
  resolveVariable = null,
  sectionBoundaries = false,
} = {}) {
  const extensions = [
    StarterKit.configure({
      heading: { levels: [2, 3] },
      codeBlock: false,
      code: false,
      blockquote: false,
      horizontalRule: false,
      strike: false,
    }),
    Link.configure({
      openOnClick: false,
      autolink: false,
      protocols: ['http', 'https', 'mailto'],
    }),
    Placeholder.configure({ placeholder }),
    VariableChip.configure({ resolveVariable }),
  ];
  if (sectionBoundaries) extensions.push(SectionBoundary);
  return extensions;
}
